import React, { Fragment } from 'react';
import { TCreateSideMenu } from '../SideMenu';

const indexFinder = (compArr: any[], nextAcc: number) =>
	compArr.length - 1 > nextAcc ? nextAcc : compArr.length - 1;
/**
 * `link` and `linkParams` are concatenated for the sake of usability by AEM as of 4-13-22
 */
const SideMenuFactory = (
	createSideMenu: TCreateSideMenu,
	TitleComponents: any[],
	LinkComponents: any[],
	linkClass: string,
	nextAcc = 0,
) => {
	const TitleType = TitleComponents[indexFinder(TitleComponents, nextAcc)];
	const LinkType = LinkComponents[indexFinder(LinkComponents, nextAcc)];
	if (createSideMenu) {
		const target: TAnchorTarget = createSideMenu.newTab
			? '_blank'
			: '_self';
		if (createSideMenu.link) {
			const { title, link, linkParams } = createSideMenu;
			const href = `${link}${linkParams || ''}`;
			if (createSideMenu.next) {
				const { next } = createSideMenu;
				if (Array.isArray(next)) {
					return (
						<>
							<LinkType
								href={href}
								target={target}
								className={linkClass}
							>
								{title}
							</LinkType>
							{next.map((child, index) => (
								<Fragment key={index + Math.random()}>
									{SideMenuFactory(
										child,
										TitleComponents,
										LinkComponents,
										linkClass,
										nextAcc + 1,
									)}
								</Fragment>
							))}
						</>
					);
				}
				return (
					<>
						<LinkType
							href={href}
							target={target}
							className={linkClass}
						>
							{title}
						</LinkType>
						{SideMenuFactory(
							next,
							TitleType,
							LinkType,
							linkClass,
							nextAcc + 1,
						)}
					</>
				);
			}
			return (
				<LinkType href={href} target={target} className={linkClass}>
					{title}
				</LinkType>
			);
		}
		if (createSideMenu.next) {
			const { title, next } = createSideMenu;
			if (Array.isArray(next)) {
				return (
					<>
						<TitleType>{title}</TitleType>
						{next.map((child, index) => (
							<Fragment key={index + Math.random()}>
								{SideMenuFactory(
									child,
									TitleComponents,
									LinkComponents,
									linkClass,
									nextAcc + 1,
								)}
							</Fragment>
						))}
					</>
				);
			}
			return (
				<>
					<TitleType>{title}</TitleType>
					{SideMenuFactory(
						next,
						TitleComponents,
						LinkComponents,
						linkClass,
						nextAcc + 1,
					)}
				</>
			);
		}
		const { title } = createSideMenu;
		return <TitleType>{title}</TitleType>;
	} else {
		console.error('There is no data being passed in.');
	}
};

export default SideMenuFactory;
